import React from "react";
import axios from "axios";

export default axios.create({
    // baseURL:"http://linkedin-backend.centralindia.cloudapp.azure.com/"
    baseURL:"https://connectplus.scriptclub.tech/"
})
